import { useSignal } from "@preact/signals";
import { useCart } from "apps/vtex/hooks/useCart.ts";
// import { useUI } from "$store/sdk/useUI.ts";
import Button from "$store/components/ui/Button.tsx";
import Icon from "$store/components/ui/Icon.tsx";
import { sendEvent } from "$store/sdk/analytics.tsx";
import { toAnalytics } from "$store/sdk/ga4/transform/toAnalytics.ts";
import type { ToAddToCart } from "$store/sdk/ga4/events/add_to_cart.ts";

export interface ItemProps {
  id: string;
  seller: string;
  quantity: number;
}

interface AddToCartProps {
  items: ItemProps[];
  disabled?: boolean;
  customClass?: string;
  analytics?: ToAddToCart;
}

let minicartDrawer: HTMLInputElement | null;

export function AddToCartMultiSku(
  { items, disabled, customClass, analytics }: AddToCartProps,
) {
  const isAddingToCart = useSignal(false);
  // const { displayCart } = useUI();
  const { addItems } = useCart();
  const isDisabled = items.length === 0 || disabled;

  const handleAddItems = async (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      isAddingToCart.value = true;
      await addItems({ orderItems: items });

      if (analytics) {
        const add_to_cart = toAnalytics({
          type: "add_to_cart",
          data: analytics,
        });

        sendEvent(add_to_cart);
      }

      if (!minicartDrawer) {
        minicartDrawer = document.querySelector("#minicart-drawer");
      }

      if (minicartDrawer) minicartDrawer.checked = true;
    } finally {
      isAddingToCart.value = false;
    }
  };

  return (
    <Button
      disabled={isDisabled}
      onClick={handleAddItems}
      class={`w-full h-12 rounded-lg bg-tw-secondary-200 text-white text-xl font-bold transition-colors duration-300 flex justify-center items-center gap-2 hover:bg-tw-secondary-300 ${customClass}`}
    >
      <Icon
        id="Cart"
        class="hidden lg:block"
        width={25}
        height={22}
      />
      Comprar
    </Button>
  );
}
